import ImageButton from 'core/display/buttons/ImageButton'
import Container from 'core/display/Container'
import Text from 'core/display/simple/Text'
import { signal } from 'services/SignalsService'
import { popups } from 'settings/popups'
import { Device } from 'utils/Device'

const template = {}
const removedButtons = []
const cache = {}
const buttons = new Container()
let orientation
const deviceIsMobile = getMobileOperatingSystem()
function makeButton(name) {
  Object.assign(template, { name, text: name })
  const button = new Container()
  let image = new ImageButton(template)
  let text = new Text(template)

  if (text.width > image.width) {
    text.text.style.fontSize = 15
  }
  text.x = image.x = image.width / 2

  button.addChild(image, text)

  if (deviceIsMobile === false && name === 'reload') {
    button.children.forEach((child) => {
      child.visible = false
    })
  }

  if (game.models.GameModel.blockGameOnError === true) {
    if (deviceIsMobile === false && name === 'reload') {
      button.children.forEach((child) => {
        child.visible = false
      })
    }

    if (name === 'continue') {
      removedButtons.push(button)
    }

    return button
  }

  if (
    game.models.GameModel.blockGameOnError === false &&
    game.models.GameModel.isFinishedContext === false
  ) {
    if (name === 'continue') {
      removedButtons.push(button)
    }

    if (name === 'reload' && deviceIsMobile === true) {
      button.children.forEach((child) => {
        child.visible = true
      })
    }

    return button
  }
  else if (
    game.models.GameModel.blockGameOnError === false &&
    game.models.GameModel.isFinishedContext === true
  ) {
    if (game.models.GameModel.requestAgainAllowed === true) {
      if (name === 'continue') {
        button.children.forEach((child) => {
          child.visible = true
        })
      }

      if (name === 'reload') {
        button.children.forEach((child) => {
          child.visible = false
        })
      }
      return button
    }
    else {
      if (name === 'continue') {
        removedButtons.push(button)
      }

      if (name === 'reload' && deviceIsMobile === true) {
        button.children.forEach((child) => {
          child.visible = true
        })
      }
    }

    return button
  }
  return button
}

function getMobileOperatingSystem() {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera

  if (/windows phone/i.test(userAgent)) {
    return true
  }

  if (/android/i.test(userAgent)) {
    return true
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return true
  }

  if (Device.isMobile()) {
    return true
  }

  return false
}

signal.on('RESIZE', (ori) => {
  orientation = ori
  setPosition()
})

function setPosition() {
  if (orientation.orientation === 'land') {
    buttons.x = 0
  }
  else {
    buttons.x = -10
  }
}

function toButton(name, idx) {
  cache[name] = cache[name] || makeButton(name)
  cache[name].x = template.width * idx * 1.5

  return cache[name]
}

function setButtonPosition(child, idx) {
  child.x = template.width * idx * 1.5
}

function cleanCache() {
  Object.keys(cache).forEach((key) => {
    cache[key].removeChildren()
    delete cache[key]
  })
}

signal.on('POPUP:show', function (value) {
  if (popups[value].buttons.length) {
    buttons.removeChildren()
    cleanCache()

    let popupsButtons = popups[value].buttons

    buttons.addChild(...popupsButtons.map(toButton))

    if (removedButtons.length > 0) {
      removedButtons.forEach((button) => {
        buttons.removeChild(button)
      })

      buttons.children.forEach(setButtonPosition)
    }

    buttons.pivot.x = buttons.width / 2
    buttons.y = 50
    setPosition()
  }
})

export function makePopupButton(data) {
  Object.assign(template, data, { x: 0, y: 0, orientation: false })

  const self = new Container()
  self.addChild(buttons)

  return self
}
